import Breadcrumb from '@/components/base/Breadcrumb';

export default function ContactHero() {
  return (
    <>
      {/* Hero */}
      <section
        className="relative pt-24 pb-16 bg-cover bg-top"
        style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=natural%20green%20office%20entrance%20building%20exterior%20with%20lush%20plants%20clean%20minimalist%20architecture%20soft%20morning%20sunlight%20warm%20inviting%20biotech%20company%20facade%20nature%20inspired%20design%20serene%20environment&width=1600&height=560&seq=contact-info-hero&orientation=landscape')" }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/28 to-black/45" />
        <div className="relative max-w-screen-xl mx-auto px-6 lg:px-10">
          <Breadcrumb
            items={[
              { label: '首頁', href: '/' },
              { label: '聯絡我們' },
            ]}
            className="mb-4 text-white/60"
          />
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-[0.8125rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-white/30">
            聯絡我們
          </span>
          <h1 className="text-white font-bold text-[2.25rem] md:text-[3rem] leading-tight mb-4 max-w-2xl">
            聯絡我們
          </h1>
          <p className="text-white/85 text-[1.0625rem] leading-[1.8] md:whitespace-nowrap">
            歡迎透過以下方式聯繫康永生技，無論電話、Email 或 LINE，我們都樂意為您服務。
          </p>
          <div className="mt-6 h-0.5 w-14 bg-[#81C784] rounded-full" />
        </div>
      </section>

      {/* Quick contact CTA row */}
      <div className="bg-[#f7faf7] border-b border-gray-100">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 py-5">
          <div className="flex flex-col sm:flex-row flex-wrap gap-3">
            <a
              href="https://lin.ee/X7Hcpf4"
              rel="nofollow"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill text-base" />
              </div>
              加入 LINE 官方帳號
            </a>
            <a
              href="tel:04-22029858"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-green-50 font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-base" />
              </div>
              電話聯絡
            </a>
            <a
              href="mailto:natural1070606@gmail.com"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-gray-300 text-[#1a2e1a] hover:border-[#4CAF50] hover:text-[#4CAF50] font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-base" />
              </div>
              Email 聯絡
            </a>
          </div>
        </div>
      </div>
    </>
  );
}